import { Spin } from "antd";
import ViewInsights from "components/organisms/ViewInsights";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

class ViewInsightsHomeOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.viewId !== this.props.viewId && this.props.viewId) {
            this.setState({ loading: true });
            this.props.getViewById(this.props.viewId);
        }

        if (prevProps.getViewByIdResult !== this.props.getViewByIdResult) {
            this.setState({ loading: false });
        }
    }

    render() {
        return (
            <Spin spinning={this.state.loading} size="small">
                <ViewInsights view={this.props.viewDetail} />
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    viewDetail: state.views.viewDetail,
    getViewByIdResult: state.views.getViewByIdResult,
});

const mapDispatchToProps = (dispatch) => ({
    getViewById: (viewId) => dispatch(actions.getViewByIdRequest(viewId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewInsightsHomeOverview));
